/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './insurance-policy.reducer';

export const InsurancePolicy = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const insurancePolicyList = useAppSelector(state => state.insurancePolicy.entities);
  const loading = useAppSelector(state => state.insurancePolicy.loading);
  const totalItems = useAppSelector(state => state.insurancePolicy.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="insurance-policy-heading" data-cy="InsurancePolicyHeading">
        <Translate contentKey="tinyMedicRestApp.insurancePolicy.home.title">Insurance Policies</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.insurancePolicy.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/insurance-policy/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.insurancePolicy.home.createLabel">Create new Insurance Policy</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.insurancePolicy.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {insurancePolicyList && insurancePolicyList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('expiryDate')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.expiryDate">Expiry Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expiryDate')} />
                </th>
                <th className="hand" onClick={sort('policyNumber')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.policyNumber">Policy Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('policyNumber')} />
                </th>
                <th className="hand" onClick={sort('allowedMoney')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.allowedMoney">Allowed Money</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allowedMoney')} />
                </th>
                <th className="hand" onClick={sort('usedMoney')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.usedMoney">Used Money</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usedMoney')} />
                </th>
                <th className="hand" onClick={sort('status')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.status">Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('status')} />
                </th>
                <th className="hand" onClick={sort('insuranceType')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.insuranceType">Insurance Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('insuranceType')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('employerName')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.employerName">Employer Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('employerName')} />
                </th>
                <th className="hand" onClick={sort('lastUpdateReason')}>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.lastUpdateReason">Last Update Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdateReason')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.provider">Provider</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.insurancePolicy.subscriber">Subscriber</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {insurancePolicyList.map((insurancePolicy, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/insurance-policy/${insurancePolicy.id}`} color="link" size="sm">
                      {insurancePolicy.id}
                    </Button>
                  </td>
                  <td>{insurancePolicy.startDate}</td>
                  <td>{insurancePolicy.expiryDate}</td>
                  <td>{insurancePolicy.policyNumber}</td>
                  <td>{insurancePolicy.allowedMoney}</td>
                  <td>{insurancePolicy.usedMoney}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.InsurancePolicyStatus.${insurancePolicy.status}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.InsuranceType.${insurancePolicy.insuranceType}`} />
                  </td>
                  <td>{insurancePolicy.active ? 'true' : 'false'}</td>
                  <td>
                    {insurancePolicy.microSec ? <TextFormat type="date" value={insurancePolicy.microSec} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>
                    {insurancePolicy.timestampEntry ? (
                      <TextFormat type="date" value={insurancePolicy.timestampEntry} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {insurancePolicy.lastUpdated ? (
                      <TextFormat type="date" value={insurancePolicy.lastUpdated} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{insurancePolicy.cursor}</td>
                  <td>{insurancePolicy.employerName}</td>
                  <td>{insurancePolicy.lastUpdateReason}</td>
                  <td>
                    {insurancePolicy.provider ? (
                      <Link to={`/institution/${insurancePolicy.provider.id}`}>{insurancePolicy.provider.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {insurancePolicy.patient ? (
                      <Link to={`/gluco-user/${insurancePolicy.patient.id}`}>{insurancePolicy.patient.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {insurancePolicy.subscriber ? (
                      <Link to={`/package-subscriber/${insurancePolicy.subscriber.id}`}>{insurancePolicy.subscriber.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/insurance-policy/${insurancePolicy.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/insurance-policy/${insurancePolicy.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/insurance-policy/${insurancePolicy.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.insurancePolicy.home.notFound">No Insurance Policies found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={insurancePolicyList && insurancePolicyList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default InsurancePolicy;
